import styles from '../../index.module.scss'
import { useContext, useEffect, useMemo, useRef, useState } from 'react';
import Utils from '@utils/utils'
import { TYPETITLEMAP, IMAGE_TYPE } from '@utils/CONST'

const ModelLeftCom = (props) => {
    const { item, selectedInputImg, setSelectedInputImg } = props

    const title = (
        <>
            <p className={styles.title}>{item?.projectName}</p>
            <p>{TYPETITLEMAP[item?.imageType]}</p>
            <p>{item?.createdTime}</p>
        </>
    )
    
    const mode = (
        <p style={{ marginBottom: '24px' }}>{item?.mode == 'std' ? '标准模式' : '高品质模式'}</p>
    )
    const skinRefine = (
        <p>已开启人像皮肤优化</p>
    )
    const relight = (
        <p>已开启人像光影融合</p>
    )
    const recolor = (
        <>
            <p>目标颜色：
                <span style={{
                    display: 'inline-block',
                    backgroundColor: item.color,
                    width: '16px',
                    height: '16px',
                    borderRadius: '4px',
                    verticalAlign: 'middle'
                }}>
                </span>
                {item.color}</p>
        </>
    )
    const inputImg = (
        <>
            <p>{item?.imageType == IMAGE_TYPE.CLOTHES ? '衣服平铺图' : '输入图'}</p>
            <div className={styles.inputImg}>
                {
                    item?.inputImage?.split(',').map((inputItem) => {
                        return <img
                            className={(selectedInputImg == inputItem && item?.inputImage?.split(',').length > 1) ? styles.inputImgSelected : ''}
                            key={inputItem}
                            onClick={() => setSelectedInputImg(inputItem)}
                            src={Utils.getImgThumbnail(inputItem)} alt="" />

                    })
                }
            </div>
        </>
    )
    const poseImg = (
        <>
            <p>试衣参考图</p>
            <img src={Utils.getImgThumbnail(item?.pose?.url)} alt="" />
        </>
    )
    const poseTryonImg = (
        <>
            <p>{item?.poseRef?.custom ? "自定义参考图" : '预设参考图'}</p>
            <img src={Utils.getImgThumbnail(item?.poseRef?.url)} alt="" />
        </>
    )
    const glassesTryonImg = (
        <>
            <p>{item?.glassesRef?.custom ? "自定义参考图" : '预设参考图'}</p>
            <img src={Utils.getImgThumbnail(item?.glassesRef?.url)} alt="" />
        </>
    )
    const simTryonImg = (
        <>
            <p>{item?.poseRef?.custom ? "自定义参考图" : '预设参考图'}</p>
            <img src={Utils.getImgThumbnail(item?.poseRef?.url)} alt="" />
        </>
    )
    const modelImg = (
        <>
            {item?.keepPose ? null : <p>模特图：{
                item?.person?.custom ? "自定义模特" :
                    item?.person?.title?.split("-").pop()}</p>}

            {!item?.keepPose && <img src={Utils.getImgThumbnail(item?.person?.url)} alt="" />}
        </>
    )

    const bkgImg = (
        <>
            {
                item?.keepBkg ? null : <p>背景图：{
                    item?.background?.custom ? "自定义背景" :
                        item?.background?.title?.split("-").pop()}</p>
            }
            {!item?.keepBkg && <img src={Utils.getImgThumbnail(item?.background?.url)} alt="" />}
        </>
    )

    const shoesImg = (
        <>
            <p>{item?.shoesRef?.custom ? "自定义参考图" : '预设参考图'}</p>
            <img src={Utils.getImgThumbnail(item?.shoesRef?.url)} alt="" />
        </>
    )


    const showConent = (
        item?.imageType == IMAGE_TYPE.CLOTHES ? (
            <>
                {title}
                {mode}
                {inputImg}
                {poseImg}
                {modelImg}
                {bkgImg}
            </>
        ) : item?.imageType == IMAGE_TYPE.MODEL ?
            (
                <>
                    {title}
                    {item?.skinRefine ? skinRefine : null}
                    {item?.relight ? relight : null}
                    {inputImg}
                    {modelImg}
                    {bkgImg}
                </>
            ) : item?.imageType == IMAGE_TYPE.SHOES ?
                (
                    <>
                        {title}
                        {mode}
                        {inputImg}
                        {shoesImg}
                    </>
                ) : item?.imageType == IMAGE_TYPE.MODEL_VIDEO ?
                    (
                        <>
                            {title}
                            {inputImg}
                        </>
                    ) : item?.imageType == IMAGE_TYPE.COMMODITYRECOLOR ?
                        (
                            <>
                                {title}
                                {recolor}
                            </>
                        ) : item?.imageType == IMAGE_TYPE.COMMODITY ?
                            (
                                <>
                                    {title}
                                    {inputImg}
                                    {bkgImg}
                                </>
                            ) : item?.imageType == IMAGE_TYPE.POSE_TRYON ?
                                (
                                    <>
                                        {title}
                                        {inputImg}
                                        {poseTryonImg}
                                    </>
                                ) : item?.imageType == IMAGE_TYPE.GLASSES_TRYON ?
                                    (
                                        <>
                                            {title}
                                            {inputImg}
                                            {glassesTryonImg}
                                        </>
                                    ) : item?.imageType == IMAGE_TYPE.SIM_TRYON ?
                                        (
                                            <>
                                                {title}
                                                {inputImg}
                                                {simTryonImg}
                                            </>
                                        ) : (
                                            <>
                                                {title}
                                                {inputImg}
                                            </>
                                        )
    )





    return (
        <div className={`${styles.ModelLeftCom} _beauty_scrollbar`}>
            {showConent}
        </div>
    )
}

export default ModelLeftCom